export const CurrencyConverter = (
  amount,
  currency,
  usdRate
) => {

  return currency === "USD"
    ? amount / usdRate
    : amount;
};